import { render, staticRenderFns } from "./Co.vue?vue&type=template&id=42c4f912&scoped=true"
import script from "./Co.vue?vue&type=script&lang=js"
export * from "./Co.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c4f912",
  null
  
)

export default component.exports